var edit = {
	init: function () {
		var self = this;

		if( jQuery( '.sites-edit-view' ).length ) {
			self.loadEdit();
		}
	},

	loadEdit: function() {
	
		jQuery( '.view-preview' ).on( 'click', function(){
			document.querySelector( '.sites-edit-view__frame > iframe' ).contentWindow.location.reload();
			jQuery( '.sites-edit-view' ).addClass( 'preview-active' );
		});

		acf.do_action('ready', jQuery('body'));

		// will be used to check if a form submit is for validation or for saving
		let isValidating = false;

		acf.add_action('validation_begin', () => {
			isValidating = true;
		});

		acf.add_action('submit', ($form) => {
			isValidating = false;
		});

		jQuery('.acf-form').on('submit', (e) => {
			let $form = jQuery(e.target);
			e.preventDefault();
			// if we are not validating, save the form data with our custom code.
			if( !isValidating ) {
			// lock the form
			// acf.validation.toggle( $form, 'lock' );
			$.ajax({
				url: window.location.href,
				method: 'post',
				data: $form.serialize(),
				success: () => {
				// unlock the form
					// acf.validation.toggle( $form, 'unlock' );
				}
			});
			}
		});

	}

};

export { edit };
